/**
 * Authentication store
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  // Legacy API key support
  apiKey: string | null;
  // New JWT-based auth
  accessToken: string | null;
  refreshToken: string | null;
  user: {
    id: string;
    email: string;
    username: string;
    full_name?: string;
    tenant_id?: string;
    is_email_verified: boolean;
  } | null;
  isAuthenticated: boolean;
  username: string | null; // Legacy field
  
  setApiKey: (apiKey: string) => void;
  setAccessToken: (token: string, refreshToken?: string, user?: AuthState['user']) => void;
  setUsername: (username: string) => void;
  setUser: (user: AuthState['user']) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      apiKey: null,
      accessToken: null,
      refreshToken: null,
      user: null,
      isAuthenticated: false,
      username: null,
      
      setApiKey: (apiKey) => set({ apiKey, isAuthenticated: true }),
      
      setAccessToken: (accessToken, refreshToken, user) => 
        set({ 
          accessToken, 
          refreshToken, 
          user, 
          isAuthenticated: true,
          username: user?.username || null
        }),
      
      setUsername: (username) => set({ username }),
      
      setUser: (user) => set({ user, username: user?.username || null }),
      
      logout: () => set({ 
        apiKey: null, 
        accessToken: null,
        refreshToken: null,
        user: null,
        username: null, 
        isAuthenticated: false 
      }),
    }),
    {
      name: 'tracekit-auth',
    }
  )
);


